import axios from 'axios'
import store from '../store'
import { getToken } from '@/Utils/auth'
import { Toast } from 'vant';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_ApiUrl, // api的base_url
  // baseURL: 'https://192.168.1.135:9090', // api的base_url
  timeout: 25000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(config => {

  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
});
// respone拦截器
service.interceptors.response.use(
  response => {
    //返回消息code不唯一是都是异常
    const res = response.data
    if (res.Code !== 1) {
      Toast.fail({ message: res.Msg, });
      return Promise.reject(new Error(res.Msg))
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
      Toast.fail({
        message: '请求超时，请检查网络',
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(new Error('请求超时，请检查网络'));
    }
    // 401:未登录;
    if (error.response && error.response.status === 401) {
      store.dispatch('FedLogOut').then(() => {
        location.reload();// 为了重新实例化vue-router对象 避免bug
      })
    }
    Toast.fail({ message: error.message, });
    return Promise.reject(error)
  }
)

export default service